<template>
    <div class="demo-tabs-style1 layout">
        <Tabs
            type="card"
            active-key="key1"
            :animated="false"
        >
            <TabPane :label="$t('pdca.t1')" key="key1">
                <m-assembly-table
                    ref="pageForm"
                    thDrag
                    :formData='pdcaPending.formData'
                    :columns="pdcaPending.columns"
                    :data="pdcaPending.tableData"
                    :loading="pdcaPending.loading"
                    :currentPage="pdcaPending.settings.currentPage"
                    :pageSize="pdcaPending.settings.pageSize"
                    :total="pdcaPending.settings.total"
                    :settings="pdcaPending.settings"
                    @onSubmit='peddingOnSubmit'
                    @onPageSizeChange='peddingOnPageSizeChange'
                    @onCurrentPageChange='peddingOnPageChange'
                >
                </m-assembly-table>
            </TabPane>
            <TabPane :label="$t('pdca.t2')" key="key2">
                <m-assembly-table
                    ref="pageForm"
                    thDrag
                    :formData='pdacProcessed.formData'
                    :columns="pdacProcessed.columns"
                    :data="pdacProcessed.tableData"
                    :loading="pdacProcessed.loading"
                    :currentPage="pdacProcessed.settings.currentPage"
                    :pageSize="pdacProcessed.settings.pageSize"
                    :total="pdacProcessed.settings.total"
                    :settings="pdacProcessed.settings"
                    @onSubmit='processedOnSubmit'
                    @onPageSizeChange='processedOnPageSizeChange'
                    @onCurrentPageChange='processedOnPageChange'
                >
                </m-assembly-table>
            </TabPane>
        </Tabs>
    </div>
</template>
<script>
import axios from 'axios';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index';
import { qmsApiSwitch, getOrgCode } from '@/utils/tool';

export default {
    components: {
        mAssemblyTable,
    },
    computed: {
        orgCode() {
            return getOrgCode(this.orgList, this.getFormDataItemVal(this.pdcaPending.formData.items, 'orgId'), 'qmsId');
        },
    },
    data() {
        return {
            pdcaPending: {
                formData: {
                    row: 1,
                    items: [
                        {
                            value: '',
                            field: 'orgId',
                            filterable: true,
                            validators: {
                                required: {
                                    required: true,
                                    message: this.$t('vendorBadRecord.t5'),
                                },
                            },
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1,
                            },
                            methods: {
                                change: () => {
                                    this.pdcaPending.tableData = [];
                                    this.pdcaPending.settings.currentPage = 1;
                                },
                            },
                            options: {
                                multiple: false,
                                values: [],
                            },
                            type: 'select',
                            title: this.$t('vendorBadRecord.t6'), // 库存组织
                        },
                    ],
                },
                columns: {
                    columns: [
                        {
                            title: this.$t('pdca.t3'), // 流程主题
                            key: 'fdSubject',
                            ellipsis: true,
                            render: (h, params) => {
                                return h('a',
                                    {
                                        on: {
                                            click: () => {
                                                this.goDetail('IncomingProcess', params.row.fdId);
                                            },
                                        },
                                    },
                                    params.row.fdSubject);
                            },
                            minWidth: 450,
                        },
                        {
                            title: this.$t('pdca.t4'), // 状态
                            key: 'fdStatus',
                            width: 100,
                        },
                        {
                            title: this.$t('pdca.t5'), // 当前步骤
                            key: 'fdNodeName',
                            width: 160,
                        },
                        {
                            title: this.$t('pdca.t6'), // 当前处理人
                            key: 'fdHandlerName',
                            width: 160,
                        },
                        {
                            title: this.$t('pdca.t7'), // 发起人
                            key: 'docCreatorName',
                            width: 110,
                        },
                        {
                            title: this.$t('pdca.t8'), // 发起时间
                            key: 'fdNodeStarDate',
                            width: 180,
                        },
                    ],
                },
                tableData: [],
                settings: {
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: true,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                },
                loading: false,
            },
            pdacProcessed: {
                formData: {
                    row: 1,
                    items: [
                        {
                            value: '',
                            field: 'orgId',
                            filterable: true,
                            validators: {
                                required: {
                                    required: true,
                                    message: this.$t('vendorBadRecord.t5'),
                                },
                            },
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1,
                            },
                            methods: {
                                change: () => {
                                    this.pdcaPending.tableData = [];
                                    this.pdcaPending.settings.currentPage = 1;
                                },
                            },
                            options: {
                                multiple: false,
                                values: [],
                            },
                            type: 'select',
                            title: this.$t('vendorBadRecord.t6'), // 库存组织
                        },
                    ],
                },
                columns: {
                    columns: [
                        {
                            title: this.$t('pdca.t3'), // 流程主题
                            key: 'fdSubject',
                            ellipsis: true,
                            render: (h, params) => {
                                return h('a',
                                    {
                                        on: {
                                            click: () => {
                                                this.goDetail('ViewIncomingProcess', params.row.fdId);
                                            },
                                        },
                                    },
                                    params.row.fdSubject);
                            },
                            minWidth: 450,
                        },
                        {
                            title: this.$t('pdca.t4'), // 状态
                            key: 'fdStatus',
                            width: 100,
                        },
                        {
                            title: this.$t('pdca.t6'), // 当前处理人
                            key: 'fdHandlerName',
                            width: 160,
                        },
                        {
                            title: this.$t('pdca.t7'), // 发起人
                            key: 'docCreatorName',
                            width: 110,
                        },
                        {
                            title: this.$t('pdca.t8'), // 发起时间
                            key: 'fdStarDate',
                            width: 180,
                        },
                        {
                            title: this.$t('pdca.t9'), // 完成时间
                            key: 'fdEndDate',
                            width: 180,
                        },
                    ],
                },
                tableData: [],
                settings: {
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: true,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                },
                loading: false,
            },
            orgList: [],
            userName: '',
        };
    },
    methods: {
        peddingOnSubmit(page, pageSize, condition) {
            this.getWFListForeign('pdcaPending', page, pageSize, condition);
        },
        peddingOnPageSizeChange(page, pageSize, condition) {
            this.pdcaPending.settings.pageSize = pageSize;
            this.getWFListForeign('pdcaPending', page, pageSize, condition);
        },
        peddingOnPageChange(page, pageSize, condition) {
            this.pdcaPending.settings.currentPage = pageSize;
            this.getWFListForeign('pdcaPending', page, pageSize, condition);
        },
        processedOnSubmit(page, pageSize, condition) {
            this.getWFListForeign('pdacProcessed', page, pageSize, condition);
        },
        processedOnPageSizeChange(page, pageSize, condition) {
            this.pdacProcessed.settings.pageSize = pageSize;
            this.getWFListForeign('pdacProcessed', page, pageSize, condition);
        },
        processedOnPageChange(page, pageSize, condition) {
            this.pdacProcessed.settings.currentPage = pageSize;
            this.getWFListForeign('pdacProcessed', page, pageSize, condition);
        },
        getWFListForeign(type, pageIndex, pageSize, condition) {
            this[type].loading = true;
            axios.get(qmsApiSwitch(this, '/qms2gsc/WorkFlowEx/getWFListForeign', this.orgCode), {
                params: {
                    type: type === 'pdcaPending' ? 'DaiChuLi' : 'YiChuLi',
                    language: this.$i18n.locale,
                    userName: this.userName.toLowerCase(),
                    pageIndex,
                    pageSize,
                    ...condition,
                },
            })
                .then((res) => {
                    const { IsSucess, MainResultData } = JSON.parse(res.data.substr(1, res.data.length - 3));
                    if (IsSucess) {
                        this[type].tableData = MainResultData.data;
                        this[type].settings.total = MainResultData.total;
                    }
                })
                .finally(() => {
                    this[type].loading = false;
                });
        },
        getCurrentVendor() {
            axios.get('/gscint/vendor/getCurrentVendor', {
                params: {},
            })
                .then((res) => {
                    const { userName } = res.data.data;
                    this.userName = userName;
                });
        },
        goDetail(name, fdId) {
            this.$router.push({
                name,
                query: {
                    type: this.type,
                    fdId,
                    userName: this.userName.toLowerCase(),
                    orgCode: this.orgCode,
                },
            });
        },
    },
    async mounted() {
        await this.getSRMInvLovListNew((data) => {
            this.orgList = data;
            data.forEach((item) => {
                item.value = item.qmsId;
                item.label = item.organizationName;
            });
            this.getFormDataItemObj(this.pdcaPending.formData.items, 'orgId').options.values = data;
            this.getFormDataItemObj(this.pdacProcessed.formData.items, 'orgId').options.values = data;
        });
        this.getCurrentVendor();
    },
};
</script>
<style lang="less" scoped>
.layout {
    background: #fff;
    padding: 10px;
}
.demo-tabs-style1 > .m-tabs-card > .m-tabs-content {
    height: 120px;
    margin-top: -16px;
}

.demo-tabs-style1 > .m-tabs-card > .m-tabs-content > .m-tabs-tabpane {
    background: #fff;
}

.demo-tabs-style1 > .m-tabs.m-tabs-card > .m-tabs-bar .m-tabs-tab {
    border-color: transparent;
}

.demo-tabs-style1 > .m-tabs-card > .m-tabs-bar .m-tabs-tab-active {
    border-color: #fff;
}
.pagination {
    padding: 10px 20px;
    text-align: right;
}
</style>
